import request from "@/utils/request";

// ----------------教师均衡发展驾驶舱统计------------------//
export const teacherStatistics =(query) =>{
    return request({
        url: "/businessservice/cockpit/teacher/statistics",
        method:"get",
        params: query
    })
}

export const teacherStatisticsOrg =(query) =>{
    return request({
        url: "/businessservice/cockpit/teacher/statisticsOrg",
        method:"get",
        params: query
    })
}